import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import {uuidZodValidator} from "@vesta/global-common-typescript/validators/zodValidators";

export type ProfilePictureReference =
    | {kind: "asset"; assetId: Uuid}
    | {kind: "legacyUrl"; url: string}
    | {kind: "none"};

export function parseProfilePictureStoredValue(value: unknown): ProfilePictureReference {
    if (typeof value !== "string") {
        return {kind: "none"};
    }
    const trimmed = value.trim();
    if (trimmed === "") {
        return {kind: "none"};
    }
    const uuidParsed = uuidZodValidator.safeParse(trimmed);
    if (uuidParsed.success === true) {
        return {kind: "asset", assetId: uuidParsed.data};
    }
    if (
        trimmed.startsWith("http://") === true ||
        trimmed.startsWith("https://") === true ||
        trimmed.startsWith("data:") === true
    ) {
        return {kind: "legacyUrl", url: trimmed};
    }
    return {kind: "none"};
}
